<template>
  <div>统计详情</div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>

</style>
